import React from 'react';

import 'dayjs/locale/fr';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';


function WidgetDatePicker({ state, setState, id, text, value = null, readOnly = false }) {
  React.useEffect(() => {
    setState({
      id: id,
      value: value === null ? null:dayjs(value),
      error: false,
      errorMessage: null,
    });
  }, []);

  const handleChange = (v) => {
    setState((s) => ({ ...s, value: v, error: false }));
  };


  return (
    <>
      {state !== null &&
        <FormControl className='w-full'>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'>
            <DatePicker
              className='shadow-md shadow-gray-300'
              label={text}
              value={state.value}
              onChange={handleChange}
              renderInput={(p) => <TextField {...p} error={state.error} />}
              readOnly={readOnly}
            />
          </LocalizationProvider>
          <FormHelperText>
            {state.error && state.errorMessage}
          </FormHelperText>
        </FormControl>
      }
    </>
  );
}

export default React.memo(WidgetDatePicker);